module.exports = __webpack_public_path__ + "static/media/beer_icon_yellow.8cfc690e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/beer_icon_yellow.png
// module id = 92
// module chunks = 0